import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getInstructorsPage } from "@/_pages/instructors/api";
import type { InstructorsPageType } from "@/_pages/instructors/model";
import { InstructorsPage } from "@/_pages/instructors/ui";

type PageProps = {
  cms: {
    page: InstructorsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { page },
  } = props;

  return <InstructorsPage page={page} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getInstructorsPage()),
      };
    },
    { res },
  );
}

export default Page;
